'use client';

import { c as _c } from "react/compiler-runtime";
import { Tab } from '@common/components';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { Suspense, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { UnauthQueryOptions } from '@/api';
import { useScrollToSection } from '@/app/donation/_hooks/useScrollToSection';
import { DONATION_ROUTES } from '@/constants';
import { BREAKPOINTS } from '@/constants/breakpoints';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useMediaQuery } from '@/hooks/useMediaQuery';
import { TABS, TABS_LABELS } from '../constants';
interface DetailTabProps {
  className?: string;
  businessId: number;
}
const DetailTabComponent = t0 => {
  const $ = _c(30);
  const {
    className,
    businessId
  } = t0;
  const {
    replace
  } = useCustomRouter();
  const isDesktopViewport = useMediaQuery(BREAKPOINTS.DESKTOP, true);
  const {
    scrollToSectionWithTab
  } = useScrollToSection();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("tab") as TABS ?? TABS.BASIC;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const tab = t1;
  let t2;
  let t3;
  if ($[2] !== scrollToSectionWithTab || $[3] !== searchParams) {
    t2 = () => {
      if (searchParams?.get("tab")) {
        scrollToSectionWithTab(searchParams.get("tab") as TABS, {
          behavior: "instant"
        });
      }
    };
    t3 = [scrollToSectionWithTab, searchParams];
    $[2] = scrollToSectionWithTab;
    $[3] = searchParams;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== businessId) {
    t4 = UnauthQueryOptions["get:/wello/v2/allows/home/donation-business/{donationBusinessId}/detail-count"]({
      path: {
        donationBusinessId: businessId
      }
    });
    $[6] = businessId;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = {
      ...t4,
      select: _temp,
      placeholderData: keepPreviousData
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: data_0
  } = useQuery(t5);
  const t6 = isDesktopViewport ? "lg" : "sm";
  const t7 = tab ?? TABS.BASIC;
  let t8;
  if ($[10] !== businessId || $[11] !== replace || $[12] !== searchParams) {
    t8 = value => {
      replace(DONATION_ROUTES.HOMETOWN_BUSINESS_DETAIL.withSearchParams({
        searchParams: {
          ...searchParams,
          tab: value
        },
        dynamicPath: {
          id: businessId
        }
      }));
    };
    $[10] = businessId;
    $[11] = replace;
    $[12] = searchParams;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Tab.Item value={TABS.BASIC}>{TABS_LABELS[TABS.BASIC]}</Tab.Item>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== data_0?.donationCount) {
    t10 = data_0?.donationCount?.toLocaleString();
    $[15] = data_0?.donationCount;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <Tab.Item value={TABS.DONATIONS}>{TABS_LABELS[TABS.DONATIONS]} {t10}</Tab.Item>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== data_0?.donationBusinessCommentCount) {
    t12 = data_0?.donationBusinessCommentCount?.toLocaleString();
    $[19] = data_0?.donationBusinessCommentCount;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <Tab.Item value={TABS.COMMENTS}>{TABS_LABELS[TABS.COMMENTS]}{" "}{t12}</Tab.Item>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== className || $[24] !== t11 || $[25] !== t13 || $[26] !== t6 || $[27] !== t7 || $[28] !== t8) {
    t14 = <Tab className={className} size={t6} variant="full" value={t7} onChange={t8}>{t9}{t11}{t13}</Tab>;
    $[23] = className;
    $[24] = t11;
    $[25] = t13;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
};
export const DetailTab = props => {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ErrorBoundary fallback={null}><Suspense><DetailTabComponent {...props} /></Suspense></ErrorBoundary>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(data) {
  return data.context;
}